import { InPersonLocation, ModalityType } from '../../models/calendar/CalendarV2'

/**
 * Constants currently used for /availability API for calendar service
 */
export const SLICE_DURATION_MINUTES = 30
export const SLICE_DURATION_USER_MINUTES = 60
export const DAILY_START_TIME = '07:00:00'
export const DAILY_END_TIME = '22:00:00'
export const FOURTEEN_DAYS_TO_MS = 1.21e9
export const SIXTY_DAYS_TO_MS = 5.184e9

export enum PHONE_TYPES {
  MOBILE = 'mobile',
  LANDLINE = 'landline',
}

export type CalendarAppointment = {
  time: string
  date: string
  timeZone: string
}

export type CalendarAppointmentWithModality = {
  date: string
  time: string
  duration?: number
  modalityType?: ModalityType
  appointmentLocation?: InPersonLocation
}

export enum BOOKING_CHANNEL_TYPE {
  CLIENT_REBOOKING = 'client_rebooking',
  DIRECT_BOOKING_LINK = 'direct_booking_link',
  DIRECT_PATH = 'direct_program_link',
  TRIAGE = 'triage',
  CNT_BOOKING = 'cnt_booking',
  FAVORITED_PROVIDERS = 'favorited_providers_booking',
  SAVED_PROVIDER_RESULTS_REENGAGEMENT_EMAILS = 'saved_provider_results_reengagement_emails',
  PP_API_AUTO_APPT_CREATION = 'pp_api_auto_appt_creation',
}
